import { getDaysInMonth, getYear } from 'date-fns';
import * as yup from 'yup';

const getValueFromString = (val: string | undefined): number | undefined => {
  if (typeof val === 'string') {
    const parsedVal = parseInt(val);
    return !isNaN(parsedVal) ? parsedVal : undefined;
  }
  return undefined;
};
export const birthDateSchema = yup
  .object({
    day: yup
      .string()
      .trim()
      .required()
      .test({
        name: 'isDayGreaterThanZero',
        test: (val: string | undefined) => {
          const parsedVal = getValueFromString(val);
          return parsedVal !== undefined && parsedVal > 0;
        },
      })
      // @ts-ignore
      .when(['month', 'year'], (month: string | undefined, year: string | undefined, schema) => {
        const parsedMonth = getValueFromString(month);
        const parsedYear = getValueFromString(year);
        if (parsedMonth !== undefined && parsedYear !== undefined) {
          return schema.test({
            name: 'isDayInMonth',
            test: (val: string | undefined) => {
              const parsedVal = getValueFromString(val);
              return parsedVal != null && parsedVal <= getDaysInMonth(new Date(parsedYear, parsedMonth - 1));
            },
          });
        }

        return schema.max(31);
      }),
    month: yup
      .string()
      .trim()
      .required()
      .test({
        name: 'isMonthGreaterThanOrEqualToOne',
        test: (val: string | undefined) => {
          const parsedVal = getValueFromString(val);
          return parsedVal != null && parsedVal >= 1;
        },
      })
      .test({
        name: 'isMonthLessThanOrEqualToTwelve',
        test: (val: string | undefined) => {
          const parsedVal = getValueFromString(val);
          return parsedVal != null && parsedVal <= 12;
        },
      }),
    year: yup
      .string()
      .trim()
      .required()
      .test({
        name: 'isMonthGreaterThanOrEqualTo1900',
        test: (val: string | undefined) => {
          const parsedVal = getValueFromString(val);
          return parsedVal != null && parsedVal >= 1900;
        },
      })
      .test({
        name: 'isMonthLessThanOrEqualToCurrentYear',
        test: (val: string | undefined) => {
          const parsedVal = getValueFromString(val);
          return parsedVal != null && parsedVal <= getYear(new Date());
        },
      }),
  })
  .defined();

export type BirthDateSchema = yup.InferType<typeof birthDateSchema>;
